export default {
  // 人员矩阵
  personnelMatrix: {
    //流程配置器
    personnelMatrix: 'Personnel Matrix',
    matrixConfiguration: 'Matrix configuration',
    selectMatrix: 'Select personnel matrix',
    selectMappingRelationship: 'Select mapping relationship',
    selectPersonnelMaintenance: 'Select personnel maintenance',
    selectReferenceDep: 'Select reference department',
    formData: 'form data',
    selectApprovalPersonnel: 'Select approver',
    jobPosSelect: 'Job selection',
    placeholder: {
      matrix: 'Please select matrix',
      depCompoment: 'Please select department components',
      josPos: 'Please select a position'
    },
    personnelMatrixNote:
      'For companies with many people and complex relationships, personnel matrix settings can meet the needs of multi-dimensional personnel relationship correlation.',
    searchPlaceholder: 'Search matrix name or code',
    noData: 'No data',
    referenceQuery: 'Reference Query',
    addMatrix: 'Add Matrix',
    matrixName: 'Matrix Name',
    matrixCode: 'Matrix Code',
    delMatrixReferenceTip: 'Please clear the data in the approval process before deleting it',
    changeMatrixStatusReferenceTip:
      'Please clear or delete the reference in the approval process before closing it',
    jobMaintenance: 'Job Maintenance',
    mappingRelationship: 'Mapping Relationship',
    jobMaintenanceTip:
      'Maintain the approval positions involved in the position matrix first, and then maintain the mapping relationship',
    addJobPosition: 'Add Position',
    editJobPosition: 'Editorial position',
    jobPositionName: 'Job Title',
    jobPositionCode: 'Position Code',
    editJobPositionEmptyTip: 'The position does not exist.',
    delJobPosImportTip:
      'Please clear the personnel data in the "Mapping Relationship" before deleting it',
    // 映射关系页面
    orgProtection: 'Job Maintenance',
    removeFilter: 'Remove Filter',
    department: 'Department',
    position1: 'Position 1',
    position2: 'Position 2',
    position3: 'Position 3',
    selectOrgTip: 'Please select an organization node on the left to view the mapping relationship',
    mappingTip: 'Members in job maintenance, bind the {dept} corresponding to {count} people',
    batchMaintenance: 'Batch Maintenance',
    exportMatrix: 'Export Matrix',
    selectPersonnel: 'Select Personnel',
    searchPersonnel: 'Search Personnel',
    add: 'Add',
    syncReplaceChildren: 'Sync Replace Children',
    // 批量维护弹窗
    downloadLatestTemplate: 'Download Latest Template',
    importTemplate: 'Import Template',
    complete: 'Complete',
    prepareImportData:
      'Please prepare the data to be imported according to the data template format',
    batchMaintenanceNote1:
      'Template header names cannot be changed, header rows cannot be deleted, row content cannot be deleted or added',
    batchMaintenanceNote2: 'Import format is xlsx, data import is overwrite import',
    batchMaintenanceNote3:
      'Personnel must be existing employee IDs within the organizational structure, otherwise import fails. Must download the latest template every time; multiple people separated by English commas',
    clickDownloadTemplate: 'Click to download the latest import template',
    selectImportTemplate: 'Please select the data template to be imported',
    addFile: 'Add File',
    fileName: 'File Name',
    previousStep: 'Previous Step',
    startImport: 'Start Import',
    addSuccess: 'Added Successfully',
    importExceptionDescription: 'Import Exception Description',
    serialNumber: 'Serial No.',
    listHeaderAdjusted: 'List header fields adjusted',
    rowHeaderAdjusted: 'Row header fields adjusted',
    personnelNotExist: 'Personnel does not exist',
    mattersNeedingAttention: 'Matters Needing Attention',
    nextStep: 'Next Step',
    onlyOneFile: 'Only one file is allowed per upload',
    pleaseSelectFile: 'Please select a file',
    downloadStart: 'Download started',
    importFailed: 'Import failed',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed'
  }
}
